module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!./App.lazybundle.js"));
	}, "App.lazybundle");
}